export enum Viewport {
    LARGE = "1200px",
    MEDIUM = "750px",
    SMALL = "400px"
}